import { State as AccessCodeDetailsState } from "@client/reducers/access-code-details-reducer";
import { Selector } from "@ngrx/store";
export const getIsActive: Selector<AccessCodeDetailsState, boolean> = (state: AccessCodeDetailsState) => state.isActive;
